<cv-generic-export [disabled]="disabled" [items]="items" [fileName]="fileName"></cv-generic-export>
